import { useMutation } from 'react-query'
import axios from 'axios'

export function useSaveResourcesTemplateMutation(onSuccess?: (data: any) => void) {
  return useMutation(
    async ({ name, template_data }: { name: string; template_data: any }) => {
      const response = await axios.post('/api/resources_templates', {
        name,
        template_data,
      })
      return response.data
    },
    {
      onSuccess,
    }
  )
}

export function useUpdateResourcesTemplateMutation(onSuccess?: (data: any) => void) {
  return useMutation(
    async ({ id, name, template_data }: { id: number; name: string; template_data?: any }) => {
      const payload: any = { name }
      if (template_data) {
        payload.template_data = template_data
      }
      const response = await axios.put(`/api/resources_templates/${id}`, payload)
      return response.data
    },
    {
      onSuccess,
    }
  )
}

export function useDeleteResourcesTemplateMutation(onSuccess?: () => void) {
  return useMutation(
    async (templateId: number) => {
      await axios.delete(`/api/resources_templates/${templateId}`)
    },
    {
      onSuccess,
    }
  )
}
